import { SVGProps, Ref, forwardRef } from 'react';

export const StarOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="m12.672 10.721-.136-.558.466-.392c2.16-1.816 3.24-2.723 2.953-3.588s-1.705-.977-4.54-1.202l-.603-.047-.243-.573C9.475 1.787 8.928.5 8 .5S6.526 1.787 5.432 4.36l-.244.574-.603.047C1.75 5.206.332 5.318.045 6.183s.793 1.772 2.952 3.588l.437.367-.141.583c-.658 2.713-.987 4.07-.237 4.604s1.965-.192 4.393-1.644l.533-.319.534.32c2.428 1.451 3.642 2.177 4.393 1.643.75-.535.42-1.891-.237-4.604m-8.019.33L5 9.625l-1.102-.926C2.8 7.776 2.091 7.175 1.667 6.708c.626-.137 1.57-.215 3.029-.331l1.448-.115.576-1.354c.566-1.33.931-2.181 1.256-2.718L8 2.15l.024.04c.325.537.69 1.388 1.256 2.718l.576 1.354 1.449.115c1.459.116 2.402.194 3.028.331-.424.467-1.133 1.068-2.231 1.991l-1.131.95.34 1.402c.34 1.403.555 2.301.614 2.921v.002l-.039-.016c-.588-.249-1.398-.729-2.652-1.479l-1.252-.748-1.251.749c-1.254.75-2.064 1.23-2.653 1.478l-.038.016v-.002c.059-.62.273-1.518.613-2.92"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
StarOutlinedSize16Glyph.displayName = 'StarOutlinedSize16Glyph';
